module.exports = "https://la-static.prod-my.games/minigames/collection/img/card_row5_4.1c1a4d9c.png";